import { render } from "./checkDescrip.vue?vue&type=template&id=6dc0a3fa&scoped=true&ts=true"
import script from "./checkDescrip.vue?vue&type=script&lang=ts"
export * from "./checkDescrip.vue?vue&type=script&lang=ts"

import "./checkDescrip.vue?vue&type=style&index=0&id=6dc0a3fa&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc0a3fa"]])

export default __exports__